import { useCallback, useMemo, useState } from "react"
import { flatten } from "shared/util"
import { TextMatch } from "shared/text"

import { useListGroup } from "interface/user/group"
import { useListUser } from "interface/user"
import { useListInvite } from "interface/user/invite"

export const useUserManagementContainer = () => {
  const [searchGroup, setSearchGroup] = useState<number[]>([])
	const [searchWord, setSearchWord] = useState("")

  const groupListState = useListGroup()
	const userListState = useListUser()
	const inviteListState = useListInvite()

	const onReload = useCallback(
		() => {
			groupListState.refetch()
			userListState.refetch()
			inviteListState.refetch()
		},
		[groupListState, userListState, inviteListState]
	)
  const groupList = useMemo(() => {
    return groupListState.data?.list ?? []
  }, [groupListState])

	const userList = useMemo(() => {
		let userList = userListState.data
		if (!userList) return null

    if (searchGroup.length > 0) {
      userList = userList.filter(user =>
				user.group && user.group.some(group =>
					searchGroup.some(groupId => group.groupId === groupId)
        )
      )
    }
		if (searchWord !== '') {
      const match = new TextMatch(searchWord)
      userList = userList.filter(user => match.match(
        user.userName,
        user.email
      ))
    }
    return userList
	}, [userListState, searchGroup, searchWord])

	const inviteList = useMemo(() => {
		const inviteList = inviteListState.data?.list
		if (!inviteList) return []
		return inviteList
	}, [inviteListState])

	return useMemo(() => ({
    loading: groupListState.loading || userListState.loading || inviteListState.loading,
    errors: flatten([groupListState.error, userListState.error, inviteListState.error]),
    groupList,
    userList,
    inviteList,
    searchGroup,
    setSearchGroup,
    searchWord,
    setSearchWord,
		onReload
	}), [
		groupListState, groupList,
		userListState, userList,
		inviteListState, inviteList,
    searchGroup, setSearchGroup,
    searchWord, setSearchWord,
		onReload
	])
}